import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient'; // 共通のapiClientをインポート

export const useFarmerPdfUrlQuery = (options?: { enabled?: boolean }) => {
  const apiClient = useApiClient(); // インスタンスを取得

  return useQuery({
    queryKey: ['reports', 'result-pdf'],
    queryFn: async () => {

      // 1. 共通設定済みのapiClientを使用する
      const response = await apiClient.get(`/reports/FarmerList`, {
        responseType: 'blob',  // バイナリ取得を明示
        // ヘッダーを上書きしてJSON固定を解除（必要に応じて）
        headers: {
          'Accept': 'application/pdf',
        }
      });

      // 2. レスポンスがHTML（メニュー画面等）になっていないかチェック
      if (response.data.type === 'text/html' || response.data.type === 'application/json') {
        throw new Error("PDFの取得に失敗しました。セッションを確認してください。");
      }

      return URL.createObjectURL(response.data);
    },
    enabled: options?.enabled,
    staleTime: 0,
    gcTime: 0,
  });
};
